if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          this.updateSku(event);  // SKU更新処理
          this.updatePoints(event);  // ポイント更新処理
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }

      // SKUの更新処理
      updateSku(event) {
        const variantDataElement = document.querySelector('[data-selected-variant]');
        if (!variantDataElement) return;

        try {
          const variantData = JSON.parse(variantDataElement.textContent);
          const newSku = variantData.sku || '';

          const skuElement = document.getElementById(`Sku-${this.dataset.section}`);
          if (skuElement) {
            skuElement.textContent = newSku;
          }
        } catch (error) {
          console.error('SKUの更新に失敗しました:', error);
        }
      }

      // 獲得予定ポイントの更新処理
      updatePoints(event) {
        const variantDataElement = document.querySelector('[data-selected-variant]');
        if (!variantDataElement) {
          console.error('Error: [data-selected-variant] element not found.');
          return;
        }
      
        try {
          const variantData = JSON.parse(variantDataElement.textContent);
      
          // デバッグ: 価格を確認
          console.log('Variant price:', variantData.price);
      
          if (!variantData.price) {
            console.error('Error: variantData.price is undefined or 0.');
            return;
          }
      
          const newPoints = Math.floor(variantData.price / 10000); // 100円 = 1ポイントの計算
      
          const pointsElement = document.getElementById(`Points-${this.dataset.section}`);
          if (pointsElement) {
            pointsElement.textContent = `${newPoints} ポイント付与`;
          }
        } catch (error) {
          console.error('ポイントの更新に失敗しました:', error);
        }
      }
    }
  );
}
